import * as ActionTypes from "../ActionTypes";

const initialState = {
  /*login & signUp*/
  // productId:"",
  // agentLoggedIn: false,
  // campaignStateEntry:false,
  // prospectStateEntry:false,
  // emailAddress: "",
  // successfulSignUp: "",
  // guestLogin: true,
  /*form*/
  storeshowpopUp: false,
  clickedSaveNextIds: [],
  physiciansData: [{ label: "---Select---", value: "" }],
  emailoptionChecked: "N",
  selectedVo: [],
  Submitted: false,
  // campaignData: [],
  // premiumAmount: "",
  preEnrollInfo: {},
  qsns: [],
  physicians: [{ label: "---Select---", value: "" }],
  authorizedrelations: [{ label: "---Select---", value: "" }],
  year: new Date().getFullYear(),
  count: 0,
  // selectedPlan: "", //id
  language: "",
  // selectedPlanName: "", //name
  // isEligible: "",
  /*plan*/
  planCardData: [],
  planDetailTable: [],
  /*dashboard*/
  dashboardStatusData: {},
  dashboardCategoryData: {},
  searchedApplication: [],
  isUpdated: false,
  formDisable: false,
  /*zip*/
  // token: "",
  zip: "",
  county: "",
  stateCd: "",
  state: "",
  // firstName: "",
  // lastName: "",
  // selectedPlanId: "",
  // selectedProductName: "",
  pendingApplFlag: false,
  zipCodes: [],
  mailingZipCodes: [],
  permanentAddrStreet: "",
  permanentCity: "",
  permanentZip: "",
  commentTableData: [],
  prospectEnroll: false,
  prospectflag: false,
  loadApi: false,
  // agencyID:"",
  search: false,
  cmpnames: [],
  KeyPerformanceByAgent: [],
  keyPerformanceByAgentEntry: false,
  KeyPerformanceByCampaign: [],
  keyPerformanceByCampaignEntry: false,
  // deeplink:false,
  dpzipCode: "",
  isCaptchaValidated: false,
  Captcha: false,
  uploadedFilesInPreEnroll: [],
  selectedProduct: "",
  selectedPlansForCompare: [],
  isAllchecked: false,
  planSelected: { planId: "", pbpId: "" },
  roles: [],
  hydrated: false,
};

export default function webAppReducer(state, action) {
  if (!state || !state.hydrated) {
    state = {
      ...initialState,
      ...state,
      hydrated: true,
    };
  }
  switch (action.type) {
    // case ActionTypes.LOGIN:
    //   // console.log("AGENT ID",action.payload.data.agentDetails.agentId)
    //   //console.log("AGENT ID",action.payload.data.agentDetails[agentId])
    //   return {
    //     ...state,
    //     guestLogin: false,
    //     selectedPlan: "",
    //     // emailAddress: action.body.username,
    //     firstName: action.payload.data.firstName,
    //     lastName: action.payload.data.lastName,
    //     agentId:
    //       action.payload.data && action.payload.data.agentDetails
    //         ? action.payload.data.agentDetails.agentId
    //         : state.agentId
    //         ? state.agentId
    //         : action.agentId,
    //   };
    // case ActionTypes.SUCCESSFUL_SIGNUP:
    //   return {
    //     ...state,
    //     successfulSignUp: action.payload,
    //   };
    case ActionTypes.GET_ZIPCODES:
      return {
        ...state,
        // planCardData: [],

        stateCd:
          action.payload.data.length === 0
            ? ""
            : action.payload.data[0].stateCode,
        stateId:
          action.payload.data.length === 0
            ? ""
            : action.payload.data[0].stateCd,
        cityName:
          action.payload.data.length === 0
            ? ""
            : action.payload.data[0].cityName,
        zipCodes: action.payload.data.length === 0 ? [] : action.payload.data,
      };
    // case ActionTypes.GUEST_LOGIN:
    //   return {
    //     ...state,
    //     guestLogin: true,
    //     selectedPlan: "",
    //   };
    // case ActionTypes.SIGNUP:
    //   return {
    //     ...state,
    //     userExist : action.payload.data,
    //   };
    case ActionTypes.LOGOUT:
      return initialState;
    case ActionTypes.STATUS_DASHBOARD:
      return {
        ...state,
        dashboardStatusData: action.payload.data,
      };
    case ActionTypes.CATEGORY_DASHBOARD:
      return {
        ...state,
        dashboardCategoryData: action.payload.data,
      };
    case ActionTypes.SAVE_LOGOUT:
      return {
        ...state,
        preEnrollInfo: action.payload.data.enrollmentVO
          ? action.payload.data.enrollmentVO
          : action.exParam,
        guestbeneagentAppNum: action.payload.data ? action.payload.data : null,
        appNum: action.payload.data ? action.payload.data : null,
      };
    //return initialState;

    case ActionTypes.SUBMIT_FORM:
      return {
        ...state,
        count: action.payload.data,
        preEnrollInfo: action.value,
      };
    case ActionTypes.SAVE_ENROLL_FORM:
      return {
        ...state,
        preEnrollInfo: action.payload.data ? action.payload.data : {},
      };
    case ActionTypes.YEAR_SELECTION:
      return {
        ...state,
        year: action.payload,
      };
    // case ActionTypes.CAMPAIGN_LIST:
    //   return {
    //     ...state,
    //     campaignData: ( action.payload.data.length > 0 )
    //     ? [...initialState.campaignData,...action.payload.data]
    //     :initialState.campaignData
    //   };

    // case ActionTypes.GET_AGENT_LIST:

    //   return {
    //     ...state,
    //      agentList:action.payload.data
    //   };

    // case ActionTypes.GET_CALLS_DATA:

    //   return {
    //     ...state,
    //      callsTableData:action.payload.data
    //   };
    //  case ActionTypes.SEARCH_PROSPECT:

    // return {
    //   ...state,
    //   prospectTableData:action.payload.data
    // };
    // case ActionTypes.GET_AGENT_IN_FORM:

    //   return {
    //     ...state,
    //     salesreplist:action.payload.data
    //   };

    // case ActionTypes.LOAD_PROSPECT_ROW:

    //   return {
    //     ...state,
    //     prospectrowData:action.payload.data
    //   };
    // case ActionTypes.CLEAR_PROSPECT_ROW_DATA:
    //   return {
    //     ...state,
    //     prospectrowData:[]
    //   };
    case ActionTypes.GET_PCPS:
      return {
        ...state,

        physiciansData: action.payload.data
          ? [...initialState.physiciansData, ...action.payload.data]
          : initialState.physiciansData,
      };
    case ActionTypes.SET_PCP_DATA:
      return {
        ...state,
        selectedVo: action.selectedVo,
      };
    case ActionTypes.PLAN_SELECTION_CONTINUE:
      return {
        ...state,
        sepList: action.payload.data.qsns.map((item) => {
          return {
            label: item.sepReasonCd,
            value: item.sepReasonCd,
            questionId: item.questionId,
          };
        }),
        electionList: action.payload.data.qsns.map((item) => {
          return {
            label: item.electionTypeDesc,
            value: item.electionType,
            questionId: item.questionId,
          };
        }),
        qsns: action.payload.data.qsns,
        physicians: action.payload.data.pcpList,
        preEnrollInfo: action.payload.data.enrollmentVO
          ? action.payload.data.enrollmentVO
          : state.preEnrollInfo,
        authorizedrelations: action.payload.data.authorizedRelationShips
          ? [
              ...initialState.authorizedrelations,
              ...Object.keys(action.payload.data.authorizedRelationShips).map(
                (value, i) => {
                  const label = Object.values(
                    action.payload.data.authorizedRelationShips
                  )[i];
                  return { label: label, value: value };
                }
              ),
            ]
          : initialState.authorizedrelations,
      };
    case ActionTypes.SET_ENROLLMENT_REDIRECT:
      let data = action.payload.data ? action.payload.data : {};
      if (data && Object.keys(data).length > 0) {
        Object.entries(data).forEach((pp) => {
          let key = pp[0],
            value = pp[1] === null ? "" : pp[1];
          data[key] = value;
        });
      }
      return {
        ...state,
        preEnrollInfo: data ? data : {},
      };
    // case ActionTypes.REMOVEPLAN: {
    //   return {
    //     ...state,
    //     selectedPlan: "",
    //   };
    // }
    case ActionTypes.SAVE_LANGUAGE: {
      return {
        ...state,
        language: action.payload,
      };
    }
    // case ActionTypes.SET_FORM_DATA: {
    //   return {
    //     ...state,
    //     selectedPlan: action.payload.planId,
    //     selectedPlanName: action.payload.planName,
    //     selectedPlanId: action.payload.plan,
    //     selectedProductName: action.payload.productName,
    //     premiumAmount: action.payload.premiumAmount,
    //     productId:action.payload.productId,
    //   };
    // }
    case ActionTypes.SET_ZIP: {
      return {
        ...state,
        [action.payload.type]: action.payload.data,
      };
    }
    // case ActionTypes.AGENT_LOGIN: {
    //   return {
    //     ...state,
    //     agentLoggedIn: action.payload,
    //     agentId: action.agentId,
    //   };
    // }
    case ActionTypes.GET_PLAN_SUMMARY: {
      return {
        ...state,
        planCardData:
          action.payload.data === "NO_DATA_FOUND"
            ? []
            : action.payload.data.planSnapshots,
        state: action.payload.data.state
          ? action.payload.data.state
          : state.state,
        county: action.payload.data.county
          ? action.payload.data.county
          : state.county,
        zip: action.payload.data.zip ? action.payload.data.zip : state.zip,
        zipCodes: action.payload.data.zipDetail
          ? action.payload.data.zipDetail
          : state.zip,
      };
    }
    case ActionTypes.GET_PLAN_SUMMARY_BY_ZIP: {
      return {
        ...state,
        planCardData:
          action.payload.data === "NO_DATA_FOUND"
            ? []
            : action.payload.data.summaryList,
        CountyCd: action.payload.data.countyCd,
      };
    }
    case ActionTypes.COMPARE_PLAN: {
      let plandetails = action.payload.data || [];
      plandetails.forEach((plan) => {
        delete plan.prescriptionDrugsData;
      });
      // const planDetailTable = [];
      // for(let i = 0; i<plandetails.length; i++) {
      //   planDetailTable.push(plandetails[i].plandetails);
      // }
      const planDetailTable = plandetails.map((plan) => plan.plansData);
      return {
        ...state,
        planDetailTable,
        plandetails,
      };
    }
    case ActionTypes.GET_CMP_NAMES: {
      return {
        ...state,
        cmpnames: action.payload,
      };
    }
    case ActionTypes.GET_PLAN_DETAILS: {
      let plandetails = [action.payload.data];
      //console.log("vty", plandetails);
      plandetails.forEach((plan) => {
        delete plan.prescriptionDrugsData;
      });
      return {
        ...state,
        planDetailTable: plandetails,
        plandetails: [{}],
      };
    }
    // case ActionTypes.SET_ELIGIBILITY: {
    //   return {
    //     ...state,
    //     isEligible: action.payload.data,
    //   };
    // }
    case ActionTypes.SEARCH_APPLICATION: {
      return {
        ...state,
        searchedApplication:
          action.payload.data.length > 0 ? action.payload.data : "No Data",
      };
    }

    // case ActionTypes.TOKEN_TO_REDUX: {
    //   return {
    //     ...state,
    //     token: action.payload,
    //   };
    // }
    // case ActionTypes.SET_LOGIN_DATA: {
    //   return {
    //     ...state,
    //     authenticatedData: action.payload,
    //   };
    // }

    // case ActionTypes.SET_EMAil: {
    //   return {
    //     ...state,
    //     emailAddress: action.payload,
    //   };
    // }
    case ActionTypes.SOA_DETAILS: {
      return {
        ...state,
        soa: {
          ...state.soa,
          [action.payload.name]: action.payload.value,
        },
      };
    }

    case ActionTypes.SOA_PRODUCT_IDS: {
      return {
        ...state,
        productIds: {
          ...state.productIds,
          [action.payload.name]: action.payload.value,
        },
      };
    }
    // case ActionTypes.AGENTEMAILID: {
    //   //console.log("gghhjh", action.payload);
    //   return {
    //     ...state,
    //     agentEmailId: action.payload,
    //   };
    // }
    // case ActionTypes.DEEPLINK: {
    //   //console.log("deeplink", action.payload.deeplink);
    //   return {
    //     ...state,
    //     deeplink: action.payload.deeplink,
    //     dpcountyName: action.payload.countyName,
    //     dpzipCode: action.payload.zipcode,
    //     dpProductId:action.payload.productId,
    //     dpStateCd:action.payload.stateCd,
    //     dpemail:action.payload.email
    //   };
    // }
    // case ActionTypes.REMOVETOKEN: {
    //   return {
    //     ...state,
    //     token: "",
    //   };
    // }
    // case ActionTypes.SET_PROSPECT_STATE: {
    //   return {
    //     ...state,
    //     prospectStateEntry: action.payload,
    //   };
    // }
    // case ActionTypes.SET_CAMPAIGN_STATE: {
    //   return {
    //     ...state,
    //     campaignStateEntry: action.payload,
    //   };
    // }
    case ActionTypes.SETPENDAPPLFLAG: {
      return {
        ...state,
        pendingApplFlag: action.payload,
      };
    }
    // case ActionTypes.SAVE_SOA_DATA: {
    //   return {
    //     ...state,
    //     leadIdNbr: action.payload.data
    //   }
    // }

    // SONAR case ActionTypes.SAVE_CALLS : {
    //   return {
    //     ...state,

    //   }
    // }
    // case ActionTypes.SAVE_PROSPECT:{
    //   return {
    //     ...state,

    //   }
    // }
    // case ActionTypes.SAVE_PROSPECT:
    // case ActionTypes.SAVE_CALLS:
    // case ActionTypes.DIGITAL_SIGN:
    //     return {
    //       ...state,

    //     }

    // case ActionTypes.SET_CALLER_ID:{
    //   return{
    //     ...state,
    //     callerID:action.payload
    //   }
    // }
    // case ActionTypes.SET_LEAD_ID:{
    //   return{
    //     ...state,
    //     leadIdNbr:action.payload.leadIdNbr,
    //     selectedData:action.payload

    //   }
    // }

    // case ActionTypes.GET_COMMENTS_DATA:{
    //   return{
    //     ...state,
    //     commentTableData:action.payload.data
    //   }
    // }
    // case ActionTypes.ADD_NEW_COMMENT:{
    //   return{
    //     ...state,
    //     nwCmtResponseData:action.payload.data
    //   }
    // }
    // case ActionTypes.LOAD_DEMOGRAPHICS:{
    //   return{
    //     ...state,
    //     demographicsData:action.payload.data,
    //   }
    // }
    // case ActionTypes.GET_CALLS_DATA_ROWSELECT:{
    //   return{
    //     ...state,
    //     callsRowData:action.payload.data,
    //   }
    // }

    // case ActionTypes.LOAD_SOA:{
    //   return{
    //     ...state,
    //     SOAData:action.payload.data,
    //   }
    // }

    // case ActionTypes.GET_AGENCYID:{
    //   return{
    //     ...state,
    //     agencyID:action.payload.data,
    //   }
    // }
    case ActionTypes.KEY_PERFORMANCE_BY_AGENT: {
      return {
        ...state,
        PerformanceByAgent: action.payload.data,
      };
    }
    case ActionTypes.KEY_PERFORMANCE_BY_AGENT_STATE: {
      return {
        ...state,
        keyPerformanceByAgentEntry: action.payload,
      };
    }
    case ActionTypes.KEY_PERFORMANCE_BY_CAMPAIGN: {
      return {
        ...state,
        KeyPerformanceByCampaign: action.payload.data,
      };
    }
    case ActionTypes.KEY_PERFORMANCE_BY_CAMPAIGN_STATE: {
      return {
        ...state,
        keyPerformanceByCampaignEntry: action.payload,
      };
    }
    // case ActionTypes.PCP_MAP_SEARCH:{
    //   return {
    //     ...state
    //   }
    // }
    //SONAR case ActionTypes.DIGITAL_SIGN:{

    //   return {
    //     ...state,
    //     // isuploaded:true
    //   }
    // }
    // case ActionTypes.GET_CAMPAIGN_NAMES:

    //       return {
    //         ...state,
    //          campaignNamesList:action.payload.data
    //       };
    // case ActionTypes.PENDING_APP_LIST:{
    //   return{
    //     ...state,
    //     pendingAppList:action.payload.data
    //   }
    // }

    case ActionTypes.MEMBERSHIP_AGENT_lIST: {
      let lists = action.payload.data;
      lists.unshift({ label: "Select", value: "" });
      return {
        ...state,
        membershipAgentList: lists,
        campaignOwnerList: lists,
      };
    }
    case ActionTypes.CAPTCHA: {
      return {
        ...state,
        isCaptchaValidated: action.payload,
        Captcha: action.payload,
      };
    }

    case ActionTypes.UPLOAD_FILES:
      return {
        ...state,
        uploadedFilesInPreEnroll: [
          ...state.uploadedFilesInPreEnroll,
          ...[action.payload],
        ],
      };
    default:
      return state;
  }
}
